import { useAuthStore } from "~/stores/useAuthStore";
const publicPathes = Object.freeze<Readonly<string[]>>([
    '/',
    '/password/.+',
    '/booking/.+',
    '/register/.+',
    '/login',
    '/errors/.+',
] as const)
const isPublicPath = (path: string): boolean => {
    if (typeof path !== 'string') return false
    const matcher = `^(${[...publicPathes].join('|')})$`
    const regex = new RegExp(matcher)
    return regex.test(path)
  }

export default defineNuxtRouteMiddleware((to,from) => {
    if(isPublicPath(to.path)){
        return;
    }
    const auth = useAuthStore();
    if(!auth.isLoggedIn) {
        return navigateTo("/login",{replace: true});
    }
})


